import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";
import { CONTACT, STATS, MANIFESTO, SERVICES, CLIENTS, HERO_IMAGE, PRODUCTS, TEAM } from "../data/content";

const DEFAULT_SITE = {
  slogan: "The core of every experience",
  logos: { name: "/brand/name.webp", name_white: "/brand/name_white.webp", k: "/brand/k.webp", k_white: "/brand/k_white.webp" },
  hero: {
    overline: "Est. 2002 — The core of every experience",
    lines: ["The Core", "Of Every", "Experience."],
    paragraph: "Registration, badging, photo-video magic, VR, AI face swaps, light painting — we engineer moments your audience actually remembers.",
    image: HERO_IMAGE,
  },
  clients: CLIENTS,
  social: { instagram: "", linkedin: "" },
  footerBlurb: "The core of every experience. Registration, badging, brand activation and AV — engineered to be remembered, since 2002.",
  contact: CONTACT,
  stats: STATS,
  manifesto: MANIFESTO,
  services: SERVICES,
  about: {
    overline: "About KORIO",
    headingLines: ["At the core", "of every", "experience."],
    intro: "KORIO is where technology, people and experiences connect — the invisible force that makes everything flow.",
    lead: "KORIO is where technology, people and experiences connect.",
    core: { title: "CORE", body: "The heart of every experience — the center everything revolves around." },
    io: { title: "I/O", body: "Input / Output — the language of technology and interaction." },
    body: "Inspired by CORE and I/O, KORIO represents the invisible force that makes everything flow. From event technology to digital interactions, KORIO connects people, data and systems to create seamless, meaningful and memorable experiences.",
    quote: "Technology at the heart of every interaction.",
    teamNote: "Real names, photos and roles are coming soon — this is a preview of the team layout.",
  },
};

const ContentContext = createContext(null);

export const ContentProvider = ({ children }) => {
  const [site, setSite] = useState(DEFAULT_SITE);
  const [products, setProducts] = useState(PRODUCTS);
  const [team, setTeam] = useState(TEAM);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/content");
      if (data.site && Object.keys(data.site).length) {
        setSite({ ...DEFAULT_SITE, ...data.site, logos: { ...DEFAULT_SITE.logos, ...(data.site.logos || {}) }, social: { ...DEFAULT_SITE.social, ...(data.site.social || {}) } });
      }
      if (Array.isArray(data.products) && data.products.length) setProducts(data.products);
      if (Array.isArray(data.team)) setTeam(data.team);
    } catch (e) {
      // keep defaults
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <ContentContext.Provider value={{ site, products, team, loading, reload: load }}>
      {children}
    </ContentContext.Provider>
  );
};

export const useContent = () => useContext(ContentContext);
